document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    const cardLink = event.target.closest('[data-product-card-link]');
    if (cardLink) {
      sessionStorage.setItem('collectionScrollPosition', window.scrollY);
    }
  });

  const loadMoreText = window.translations?.load_more || 'Load More';
  const allText = window.translations?.all || 'All';
  const productsLoadedText = window.translations?.products_loaded || 'products loaded';
  const tryAgainText = window.translations?.try_again || 'Try again';
  const loadingText = window.translations?.loading || 'Loading...';

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const scrollPosition = sessionStorage.getItem('collectionScrollPosition');
  const loadedPage = sessionStorage.getItem('loadedPage');
  const collectionUrl = window.location.pathname;
  const savedCollectionUrl = sessionStorage.getItem('collectionUrl');

  let isLoading = false;
  const loadMoreButton = document.getElementById('load-more-button');
  let shouldRestoreScroll = false;
  let restoreScrollPosition = 0;

  if (loadMoreButton) {
    sessionStorage.setItem('collectionUrl', collectionUrl);
    const newButton = loadMoreButton.cloneNode(true);
    loadMoreButton.parentNode.replaceChild(newButton, loadMoreButton);
    newButton.addEventListener('click', handleLoadMore);

    if (scrollPosition && loadedPage && collectionUrl === savedCollectionUrl) {
      restoreScrollPosition = parseInt(scrollPosition);
      shouldRestoreScroll = true;

      const currentPage = parseInt(newButton.getAttribute('data-next-page'));
      const targetPage = parseInt(loadedPage);

      if (currentPage <= targetPage) {
        const loadPages = async () => {
          for (let i = currentPage; i <= targetPage; i++) {
            await loadPage(i, newButton);
          }
          restoreScroll();
        };

        loadPages();
      } else {
        restoreScroll();
      }
    }
  }

  function restoreScroll() {
    if (shouldRestoreScroll && restoreScrollPosition > 0) {
      window.scrollTo(0, restoreScrollPosition);
      shouldRestoreScroll = false;

      sessionStorage.removeItem('collectionScrollPosition');
    }
  }
  async function loadPage(page, button) {
    if (isLoading) return Promise.resolve();

    return new Promise((resolve) => {
      isLoading = true;
      const url = button.getAttribute('data-url');
      const totalPages = parseInt(button.getAttribute('data-total-pages'));
      const sectionId = button.getAttribute('data-section-id');
      const totalProducts = parseInt(button.getAttribute('data-total-products'));

      fetch(`${url}${window.location.search ? window.location.search + '&' : '?'}page=${page}&section_id=${sectionId}`)
        .then(response => response.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const newItems = tempDiv.querySelectorAll('#product-grid > li.grid__item');
          const productGrid = document.getElementById('product-grid');

          newItems.forEach(item => {
            productGrid.appendChild(item);
          });

          const newLoadedCount = productGrid.querySelectorAll('li.grid__item:not(.grid__item--content)').length;
          const productCountElement = document.getElementById('product-count');

          if (productCountElement) {
            const displayCount = Math.min(newLoadedCount, totalProducts);
            productCountElement.textContent = `${displayCount} of ${totalProducts} products`;
          }

          const newNextPage = page + 1;
          button.setAttribute('data-next-page', newNextPage);

          if (newNextPage > totalPages || newLoadedCount >= totalProducts) {
            button.style.display = 'none';
            if (productCountElement && newLoadedCount >= totalProducts) {
              productCountElement.textContent = `${allText} ${totalProducts} ${productsLoadedText}`;
            }
          }

          isLoading = false;
          resolve();

          document.dispatchEvent(new CustomEvent('load-more-done'));
        })
        .catch(error => {
          button.innerHTML = tryAgainText;
          button.disabled = false;
          isLoading = false;
          resolve();
        });
    });
  }

  async function handleLoadMore() {
    if (isLoading) return;

    const button = this;
    const nextPage = parseInt(button.getAttribute('data-next-page'));
    const totalPages = parseInt(button.getAttribute('data-total-pages'));

    sessionStorage.setItem('loadedPage', nextPage);
    sessionStorage.setItem('collectionUrl', window.location.pathname);

    await loadPage(nextPage, button);
    button.innerHTML = loadMoreText;
    button.disabled = false;

    if (nextPage >= totalPages) {
      sessionStorage.removeItem('loadedPage');
    }
  }
  const observer = new MutationObserver(() => {
    const btn = document.getElementById('load-more-button');
    if (btn && !btn.dataset.init) {
      btn.dataset.init = true;
      btn.addEventListener('click', handleLoadMore);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});